// Fenêtre « À propos » : version, éditeur, marque, liste des contributeurs (la page de crédits que l'accord de licence
// exclusive demande, art. 6.2) et remerciements aux logiciels libres et aux sources (data/credits.js). Ouverte depuis le lien du pied de l'appli (#btnAbout), donc depuis tous les écrans.
// Les contributeurs et les auteurs de logiciels sont chacun un paragraphe (une seule ligne de texte qui revient à la ligne si besoin) ;
// ils viennent de data/contributors.js et data/credits.js et se redessinent à chaque ouverture, dans la langue courante.
// Le clic sur le lien est branché par game.js (le jeu se met en pause pendant que la fenêtre est ouverte).
import { $ } from './dom.js';
import { createDialog } from './dialog.js';
import { CONTRIBUTORS } from '../data/contributors.js';
import { LIBRARIES, SOURCES, libraryLine } from '../data/credits.js';

/** Mention d'un contributeur : « Nom » ou « Nom (rôle) » (le rôle est choisi dans la langue courante, repli sur l'anglais). */
export function contributorLine(contributor, language) {
  const role = contributor.role?.[language] ?? contributor.role?.en ?? null;
  return role ? `${contributor.name} (${role})` : contributor.name;
}

/** Une énumération sur une seule ligne, avec la conjonction de la langue : « A et B », « A, B et C » (« A, B, and C » en anglais). */
export function joinList(items, language) {
  return new Intl.ListFormat(language, { style: 'long', type: 'conjunction' }).format(items);
}

/** Ligne d'une source : « Nom · licence — note » (la note dans la langue courante), en texte simple : aucun lien, pas même sur le nom. */
export function sourceItem(source, language) {
  const item = document.createElement('li');
  item.textContent = `${source.name} · ${source.license} — ${source.note[language] ?? source.note.en}`;
  return item;
}

/** @param {{ getLanguage: () => string, contributors?: ReadonlyArray<object>, libraries?: ReadonlyArray<object>, sources?: ReadonlyArray<object> }} deps */
export function createAboutDialog({ getLanguage, contributors = CONTRIBUTORS, libraries = LIBRARIES, sources = SOURCES }) {
  const names = $('aboutContributors'); // un paragraphe : tous les contributeurs sur une seule ligne
  const libraryText = $('aboutLibraries'); // un paragraphe : tous les auteurs de logiciels et de ressources
  const sourceList = $('aboutSources');
  const trigger = $('btnAbout');
  const dialog = createDialog($('aboutOverlay'), {
    trigger,
    onOpen() {
      const language = getLanguage();
      names.textContent = joinList(contributors.map((contributor) => contributorLine(contributor, language)), language);
      libraryText.textContent = joinList(libraries.map(libraryLine), language);
      sourceList.replaceChildren(...sources.map((source) => sourceItem(source, language)));
    },
  });
  return { open: () => dialog.open(), close: dialog.close, isOpen: dialog.isOpen };
}
